export function hexToRGBA(hex, alpha) {
    hex = hex.replace("#", "");
    if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
    }
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function removeHashedIdFromURL() {
    const currentUrl = window.location.href;
    const newUrl = currentUrl.replace(/\/map\/[a-f0-9]{32}/, '/map');
    window.history.replaceState(null, '', newUrl);
}